import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import styled from '@emotion/styled';
import { 
  CalendarToday, 
  Schedule, 
  ExpandMore, 
  ExpandLess,
  ContentCut,
  Inventory,
  Save,
  CheckCircle,
} from '@mui/icons-material';

import { useFormikContext } from "formik";

import { useFormData } from "../../../contexts/FormData";

import { getAppointmentsByCustomer } from "../apiService";

import { getSoldInventoryByCustomer } from "../../Inventory/apiService";

import { Divider, Grid, lighten } from "@mui/material";

import { formatGenericDate, formatGenericTime } from "../../../utils/util";

import AutoCompleteSolo from "../../../utils/FormikFields/AutoCompleteSolo";
import { BasicFlex, InputLabel } from "../../../utils/Common";

import ToggleButtons from "../../../utils/FormikFields/ToggleButtonComponent";

import Field from "../../../utils/FormikFields/Field";

import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';

const CheckInContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 1rem;
  /* max-width: 1000px; */
  margin: 0 auto;
`;

const MainList = styled(BasicFlex)`
  flex-wrap: wrap;
  width: auto;
`;

const AppointmentCard = styled.div`
  /* background: white; */
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  /* border: 1px solid #e5e7eb; */
  border: 1px solid ${props => props.$color || props.theme.colors.secondary};
  background: ${props => lighten(props.$color, .85) || props.theme.colors.secondaryFaint};
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
`;

const AppointmentHeader = styled.div`
  /* display: flex;
  align-items: center; */
  padding: 1.6rem;
  /* background: ${props => props.theme.colors.secondaryFaint}; */
  /* color: white; */
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  
  /* &:hover {
    background: ${props => props.clickable ? 'linear-gradient(135deg, #5855eb 0%, #7c3aed 100%)' : 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'};
  } */
`;

const HeaderIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background:${props => lighten(props.$color || props.theme.colors.secondary, 0.5)};
  border-radius: 12px;
  margin-right: 16px;
  
  .MuiSvgIcon-root {
    /* color: white; */
    font-size: 24px;
  }
`;

const AppointmentInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AppointmentTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  /* color: white; */
`;

const AppointmentDate = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  /* color: rgba(255, 255, 255, 0.9); */
  font-size: 14px;
  
  .MuiSvgIcon-root {
    font-size: 16px;
  }
`;


const HeaderWigCodeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 320px;
  /* margin-left: 0; */
`;

const ToggleContainer = styled.div`
  background-color: white;
  border-radius: 3px;
`;

const WigCodeInputContainer = styled.div`
  /* display: flex; */
  /* gap: 8px; */
  /* align-items: center; */
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #6b7280;
  background: white;
  border-radius: 16px;
  border: 2px dashed #d1d5db;
  
  .MuiSvgIcon-root {
    font-size: 48px;
    color: #d1d5db;
    margin-bottom: 16px;
  }
  
  h3 {
    margin: 0 0 8px 0;
    font-size: 18px;
    font-weight: 600;
  }
  
  p {
    margin: 0;
    font-size: 14px;
  }
`;

const SelectedIcon = styled.div`
  position: absolute;
  right: 1rem;
  top: 1rem;
`

const AppointmentList = () => {
  const { values, setFieldValue } = useFormikContext() || {};

  const { formValues } = useFormData() || {};

  const { data: appointments, isLoading } = useQuery({
    queryKey: ["appointments", "customer", values?.customer_id],
    queryFn: () => getAppointmentsByCustomer(values?.customer_id),
    enabled: !!values?.customer_id
  });

  console.log(appointments, "appointmentss");

  const { data: soldWigs } = useQuery({
    queryKey: ["inventory", "customer", values?.customer_id],
    queryFn: () => getSoldInventoryByCustomer(values?.customer_id),
    enabled: !!values?.customer_id
  });

  useEffect(() => {
    setFieldValue("checked_in_wigs", appointments?.map((a) => ({...a, 
      // service_ticket_id: a?.services?.[0]?.service_ticket_id, 
      wig_source: a.wig_source || "inventory"})).filter(a => a.service_ticket_id));
  }, [appointments]);

  if (isLoading) {
    return (
      <CheckInContainer>
        <div>Loading appointments...</div>
      </CheckInContainer>
    );
  }

  if (!appointments || appointments.length === 0) {
    return (
      <Grid size={{xs: 12}}>
        <CheckInContainer>
          <EmptyState>
            <CalendarToday />
            <h3>No appointments found</h3>
            <p>This customer doesn't have any scheduled appointments yet.</p>
          </EmptyState>
        </CheckInContainer>
      </Grid>
    );
  }

  return (
    <Grid size={{xs: 12}}>
      <CheckInContainer>
        <h2 style={{ margin: '0 0 0 0', color: '#1f2937', fontSize: '2rem', fontWeight: '600' }}>
          Active Appointments For {formValues?.customer_name}
        </h2>
        
        <MainList justify="flex-start" gap="1.5rem">
        {values?.checked_in_wigs?.map((appointment, ind) => (
          <AppointmentCard key={appointment.appointment_id} $color={appointment?.block_color}>
          {appointment?.wig_id ? <SelectedIcon>
            <TaskAltRoundedIcon color="success" />
          </SelectedIcon> : null}
            <AppointmentHeader>
              <BasicFlex>
                <HeaderIcon $color={appointment?.block_color}>
                  <Schedule />
                </HeaderIcon>
                <AppointmentInfo>
                  <AppointmentTitle>{appointment.title}</AppointmentTitle>
                  <AppointmentDate>
                    <CalendarToday />
                    {formatGenericDate(appointment.appointment_date)}, {formatGenericTime(appointment.start_time)}
                  </AppointmentDate>
                </AppointmentInfo>
              </BasicFlex>

              <Divider sx={{my: 1}} />
                <HeaderWigCodeSection>
                  <div>
                  <InputLabel>Wig Source</InputLabel>
                    <ToggleContainer>
                      <ToggleButtons name={`checked_in_wigs.${ind}.wig_source`} options={[{label: "Inventory", value: "inventory"}, {label: "External", value: "external"}]} color="info" size="small" />
                    </ToggleContainer>
                  </div>
                  <WigCodeInputContainer>
                    <InputLabel>Wig Code</InputLabel>
                    {appointment?.wig_source === "external" ? (<Field name={`checked_in_wigs.${ind}.wig_id`} style={{backgroundColor: 'white'}} />) : (
                      <AutoCompleteSolo name={`checked_in_wigs.${ind}.wig_id`} label="Wig Code" url="inventory" fieldName="wig_id" style={{backgroundColor: 'white'}}
                      serverOptions={soldWigs}
                      // forceServer={true}
                      />
                    )}
                  </WigCodeInputContainer>
                  <div>
                    <InputLabel>Notes</InputLabel>
                    <Field name={`checked_in_wigs.${ind}.notes`} style={{backgroundColor: 'white'}} multiline rows={2} />
                  </div>
                </HeaderWigCodeSection>
            </AppointmentHeader>
          
          </AppointmentCard>
        ))}
        </MainList>
      </CheckInContainer>
    </Grid>
  );
};

export default AppointmentList;